// 属性

import { hasPermission } from '@/utils/permission'

const ApplicationTab = {
  name: 'Application',
  label: 'public.attribute'
}

// 上报规则
const RuleTab = {
  name: 'EscalRule',
  label: 'public.escalation_rules'
}
// 网络参数
const NetTab = {
  name: 'NetParam',
  label: 'public.net_param'
}

// 声光报警参数
const SoundLightAlarmTab = {
  name: 'SoundLightAlarm',
  label: 'public.sound_light_alarm'
}

// Gps定位
const GpsTab = {
  name: 'GpsLocate',
  label: 'public.gps_param'
}

export const getTabs = function (type) {
  let tabs = []
  switch (type) {
    // 7~8 普通二代温度计
    case 7:
    case 8:
      tabs = [ApplicationTab, RuleTab]
      break
    // 4g温度计不带GPS
    case 9:
    case 10:
      tabs = [ApplicationTab, RuleTab, SoundLightAlarmTab]
      break
    // 4g温度计带GPS
    case 11:
    case 12:
      tabs = [ApplicationTab, RuleTab, SoundLightAlarmTab, GpsTab]
      break

    default:
      tabs = [ApplicationTab, RuleTab, NetTab]
      break
  }

  /**
   * tabs权限校验
   */
  return tabs.filter(tab => {
    switch (tab.name) {
      // 应用|上报规则
      case 'Application':
        return true
      case 'EscalRule':
        return hasPermission(['viewSensorAppConfig'])
      case 'NetParam':
        // 网络参数
        return hasPermission(['viewSensorNetConfig'])
      case 'SoundLightAlarm':
        // 声光报警参数
        return hasPermission(['viewSensorAlarmConfig'])
      case 'GpsLocate':
        // gps定位参数
        return hasPermission(['viewSensorGpsConfig'])
      default:
        return true
    }
  })
}
